import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutoResizeDirective } from './directives/auto-resize.directive';
import { FormatCnpjPipe } from '../core/pipes/format-cnpj.pipe';
import { HeaderComponent } from './header/header.component';
import { ErrorComponent } from './error/error.component';
import { ToastComponent } from './toast/toast.component';
import { AnnouncekitModule } from 'announcekit-angular';
import { MenuComponent } from './menu/menu.component';
import { ButtonComponent } from "./button/button.component";
import { PharmaSyncComponent } from "../core/components/pharma-sync/pharma-sync.component";

@NgModule({
  declarations: [
    HeaderComponent,
    ErrorComponent,
    ToastComponent,
    AutoResizeDirective,
    MenuComponent,
  ],
  exports: [
    HeaderComponent,
    ErrorComponent,
    ToastComponent,
    AutoResizeDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxMaskDirective,
    AnnouncekitModule,
    FormatCnpjPipe,
    ReactiveFormsModule,
    ButtonComponent,
    PharmaSyncComponent
],
  providers: [
    provideNgxMask()
  ]
})
export class SharedModule { }
